<template>
    <section class="w-full">
        <div class="pda-default">
            <div class="t-headline5">
                {{$t('775')}}
                <!-- 회원가입 완료! -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('776')}}<br>
                {{$t('777')}}
                <!-- {{$t('1693')}}<br>
                {{$t('1694',{str: brandName})}} -->
                <!-- 
                관리자의 가입 승인 후 학습이 가능합니다. -->
            </div>
            <div class="mgt-35">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="moveDegree()">
                    {{$t('778')}}
                    <!-- 강의 둘러보기 -->
                </button>
            </div>
        </div>  
        
    </section>
    
</template>

<script>
/**
 * 회원가입 - 승인대기(sign up - wait approved component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            brandName: '',
            studentContents: '',
            parentContents: '',
            instructorContents: '',
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    mounted() {
        this.setMaterialUi()
        this.brandName = BRAND_NAME
        this.$parent.setTopAppBarCloseOnly()
        
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['INIT_JOIN_STORE']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        moveDegree() {
            this.$router.push('/login')
        }
    },
}
</script>